import { axiosAuthService } from "./axios";

const StudentPasswordAPIs = {

    ForgotPassword: async function (values) {
        try {
            const response = await axiosAuthService.post(`/forgot_password/`, values, {
            });

            console.log('Response:', response.data);
            return response.data; // Assuming the server returns the data
        } catch (error) {
            console.error('Forgot Password Error:', error);
            throw error;
        }
    },

    ResetPassword: async function (values) {
        try {
            const response = await axiosAuthService.post(`/reset_password/`, values, {
            });

            console.log('Response:', response.data);
            return response.data; // Assuming the server returns the data
        } catch (error) {
            console.error('Reset Password Error:', error);
            throw error;
        }
    },
    FirstTimeLogin: async function (values) {
        try {
            const response = await axiosAuthService.post(`/first_time_password_change/`, values, {
            });

            console.log('Response:', response.data);
            return response.data; // Assuming the server returns the data
        } catch (error) {
            console.error('First Time Login Error:', error);
            throw error;
        }
    },
};

export default StudentPasswordAPIs;